module.exports = __webpack_public_path__ + "img/deposit.25c4d923.png";